import { graphql } from "@/lib/gql/__generated__";

export const ContactUpdateMutation = graphql(/* GraphQL */ `
	mutation ContactUpdate($input: ContactUpdateInput!) {
		contactUpdate(input: $input) {
			userErrors
			contact {
				id
				hotelID
				contactID
				title
				messages {
					message
					images {
						bucket
						key
						region
						mimeType
						fileName
					}
					senderType
					createdAt
				}
			}
		}
	}
`);
